module.exports = __webpack_public_path__ + "img/company-logo.58da0a46.svg";